import { render, staticRenderFns } from "./EstadisticaVentas.vue?vue&type=template&id=9b0e6a2a&"
import script from "./EstadisticaVentas.vue?vue&type=script&lang=js&"
export * from "./EstadisticaVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports